interface FormButtonProps {
  type?: 'button' | 'submit' | 'reset'
  children: React.ReactNode
  onClick?: () => void
  className?: string
  disabled?: boolean
}

export default function FormButton({ 
  type = 'submit', 
  children, 
  onClick,
  className = '',
  disabled = false
}: FormButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`w-full py-3 bg-gold-gradient text-white font-bold rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 ${className}`}
    >
      {children}
    </button>
  )
}

